(function () {
  'use strict';
  if (window.factsGalleryVideoReady) return;
  window.factsGalleryVideoReady = true;
  var instances = new Map();

  function init(root) {
    if (instances.has(root)) return;
    var videos = Array.from(root.querySelectorAll('[data-fpb-video]'));
    if (!videos.length) return;
    var track = root.querySelector('.fpb__stage');
    var slides = Array.from(track.querySelectorAll('.fpb__slide'));
    var radios = Array.from(root.querySelectorAll('.fpb__galradio'));
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var connection = navigator.connection;
    var states = videos.map(function (video) {
      var slide = video.closest('.fpb__slide');
      var button = slide.querySelector('[data-fpb-video-toggle]');
      var state = { video: video, slide: slide, button: button, loaded: false, pending: false, pausedByUser: false, blocked: false, retry: 0, retries: 0, wasActive: false, token: 0 };
      video.controls = video.dataset.autoplay !== 'true';
      video.playsInline = true;
      if (video.dataset.autoplay === 'true') video.defaultMuted = video.muted = true;
      button.hidden = false;
      slide.classList.add('fpb__video-ready');
      return state;
    });

    function active(state) {
      var index = slides.indexOf(state.slide);
      if (!radios[index] || !radios[index].checked || document.hidden || !root.isConnected) return false;
      var rect = state.slide.getBoundingClientRect();
      var area = track.getBoundingClientRect();
      var width = Math.max(0, Math.min(rect.right, area.right, window.innerWidth) - Math.max(rect.left, area.left, 0));
      var height = Math.max(0, Math.min(rect.bottom, area.bottom, window.innerHeight) - Math.max(rect.top, area.top, 0));
      return width >= rect.width * 0.55 && height >= Math.min(rect.height, window.innerHeight) * 0.2;
    }

    function paint(state) {
      var playing = !state.video.paused && !state.video.ended;
      state.slide.classList.toggle('fpb__video-playing', playing);
      state.button.setAttribute('aria-label', playing ? state.button.dataset.pauseLabel : state.button.dataset.playLabel);
    }

    function hydrate(state) {
      if (state.loaded) return;
      var sources = Array.from(state.video.querySelectorAll('source[data-src]'));
      sources.sort(function (a, b) { return Number(a.dataset.width) - Number(b.dataset.width); });
      var target = Math.min(1440, state.slide.clientWidth * Math.min(window.devicePixelRatio || 1, 2));
      var source = sources.find(function (item) { return Number(item.dataset.width) >= target; }) || sources[sources.length - 1];
      if (!source) return;
      state.loaded = true;
      state.video.src = source.dataset.src;
      state.video.preload = 'metadata';
      state.video.load();
    }

    function pause(state) {
      clearTimeout(state.retry);
      state.retry = 0;
      state.token++;
      state.pending = false;
      state.video.pause();
      paint(state);
    }

    function play(state, manual) {
      if (!active(state) || state.pending) return;
      if (!manual && (state.pausedByUser || state.blocked || motion.matches || (connection && connection.saveData) || state.video.dataset.autoplay !== 'true')) return;
      hydrate(state);
      if (!state.loaded) return;
      if (manual) { state.pausedByUser = false; state.blocked = false; }
      if (state.video.dataset.autoplay === 'true') state.video.muted = true;
      state.pending = true;
      var token = ++state.token;
      var result = state.video.play();
      if (result && result.then) result.then(function () {
        if (token !== state.token) return;
        state.pending = false;
        if (!active(state) || state.pausedByUser) pause(state);
        paint(state);
      }).catch(function (error) {
        if (token !== state.token) return;
        state.pending = false;
        // A browser interruption is recoverable; policy denials wait for a gesture.
        state.blocked = true;
        state.video.dataset.playbackError = error && error.name || 'PlaybackError';
        if (error && error.name === 'AbortError' && state.retries < 1 && active(state)) {
          state.retries++;
          state.retry = setTimeout(function () {
            state.retry = 0;
            state.blocked = false;
            play(state, false);
          }, 250);
        }
        paint(state);
      });
      else { state.pending = false; paint(state); }
    }

    function sync() {
      states.forEach(function (state) {
        var visible = active(state);
        if (!visible) {
          state.wasActive = false;
          if (state.pending || !state.video.paused) pause(state);
          return;
        }
        // Re-entering the slide must not inherit an earlier autoplay failure.
        if (!state.wasActive) { state.blocked = false; state.retries = 0; }
        state.wasActive = true;
        if (state.video.paused && !state.pending) play(state, false);
      });
    }

    states.forEach(function (state) {
      state.button.addEventListener('click', function () {
        if (state.pending || !state.video.paused) { state.pausedByUser = true; pause(state); }
        else play(state, true);
      });
      state.video.addEventListener('playing', function () {
        if (!active(state) || state.pausedByUser) { pause(state); return; }
        state.blocked = false;
        delete state.video.dataset.playbackError;
        state.slide.classList.add('fpb__video-started');
        paint(state);
      });
      ['pause', 'ended'].forEach(function (name) { state.video.addEventListener(name, function () { paint(state); }); });
      state.video.addEventListener('error', function () {
        state.pending = false;
        state.blocked = true;
        state.loaded = false;
        state.slide.classList.remove('fpb__video-started');
        pause(state);
      });
    });

    // Safari can require a direct user gesture. Retry on a gallery gesture only,
    // never override the visitor's explicit pause or reduced-motion/data preference.
    function galleryGesture(event) {
      if (event.target.closest('[data-fpb-video-toggle]')) return;
      states.forEach(function (state) {
        if (state.video.dataset.autoplay !== 'true' || state.pausedByUser ||
            motion.matches || (connection && connection.saveData) || !active(state)) return;
        if (state.video.paused && !state.pending) {
          state.blocked = false;
          state.retries = 0;
          play(state, false);
        }
      });
    }

    function preferenceChanged() {
      states.forEach(function (state) { pause(state); });
      sync();
    }
    function stopAll() { states.forEach(pause); }
    var observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(sync, { threshold: [0, 0.2, 0.55, 0.8] });
      states.forEach(function (state) { observer.observe(state.slide); });
    }
    var frame = 0;
    function schedule() { if (!frame) frame = requestAnimationFrame(function () { frame = 0; sync(); }); }
    track.addEventListener('scroll', schedule, { passive: true });
    track.addEventListener('touchend', galleryGesture, { passive: true });
    track.addEventListener('click', galleryGesture);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    root.addEventListener('change', schedule);
    root.addEventListener('fpb:gallery-change', sync);
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('pagehide', stopAll);
    window.addEventListener('pageshow', sync);
    motion.addEventListener('change', preferenceChanged);
    if (connection && connection.addEventListener) connection.addEventListener('change', preferenceChanged);
    instances.set(root, function () {
      states.forEach(pause);
      if (observer) observer.disconnect();
      cancelAnimationFrame(frame);
      track.removeEventListener('scroll', schedule);
      track.removeEventListener('touchend', galleryGesture);
      track.removeEventListener('click', galleryGesture);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      root.removeEventListener('change', schedule);
      root.removeEventListener('fpb:gallery-change', sync);
      document.removeEventListener('visibilitychange', sync);
      window.removeEventListener('pagehide', stopAll);
      window.removeEventListener('pageshow', sync);
      motion.removeEventListener('change', preferenceChanged);
      if (connection && connection.removeEventListener) connection.removeEventListener('change', preferenceChanged);
      instances.delete(root);
    });
    sync();
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-section-type="facts-product-buybox"]')) init(scope);
    scope.querySelectorAll('[data-section-type="facts-product-buybox"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (cleanup, root) { if (event.target.contains(root)) cleanup(); });
  });
})();
